import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";

const STEPS = [
  {
    n: "01",
    title: "Porția zilnică",
    desc: "Un borcan NOSA de 85 g, proaspăt deschis la ora mesei.",
    img: "/images/product-served-top.webp",
    alt: "Vedere de sus: borcanul NOSA deschis și farfuria cu hrană pentru pisici",
  },
  {
    n: "02",
    title: "Servire",
    desc: "Hrana se așază în farfurie, la temperatura camerei.",
    img: "/images/product-served.webp",
    alt: "Borcanul NOSA deschis, lângă farfuria cu porția servită",
  },
  {
    n: "03",
    title: "Prima gură",
    desc: "Momentul așteptat cu nerăbdare, în fiecare zi.",
    img: "/images/cat-eating-2.webp",
    alt: "Pisică tabby mâncând din farfurie, pe tăviță de lemn",
  },
  {
    n: "04",
    title: "Bol gol, mustăți fericite",
    desc: "Relaxarea de după masă spune tot.",
    img: "/images/cat-lounging.webp",
    alt: "Pisică crem relaxată lângă farfuria cu hrană NOSA",
  },
];

export default function Gallery() {
  return (
    <section id="povestea" className="relative border-t border-gold/10 py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 flex flex-col gap-6 lg:mb-20 lg:flex-row lg:items-end lg:justify-between"
        >
          <div>
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-12 bg-gold/70" />
              <p className="font-mono text-[10px] uppercase tracking-[0.38em] text-gold sm:text-[11px]">
                Ritualul mesei
              </p>
            </div>
            <h2 className="max-w-lg font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
              De la borcan, <em className="text-gold-gradient italic">la bol.</em>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-stone lg:text-base">
            Patru momente simple — aceeași grijă, de la deschiderea borcanului până la
            ultimul lingurior.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {STEPS.map((s, i) => (
            <motion.figure
              key={s.n}
              initial={{ opacity: 0, y: 44 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.12 }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
              className="group"
              data-testid={`story-step-${i}`}
            >
              <div className="relative h-64 overflow-hidden rounded-3xl border border-gold/15 lg:h-72">
                <img
                  src={s.img}
                  alt={s.alt}
                  className="h-full w-full object-cover transition-transform duration-[2s] ease-out group-hover:scale-[1.05]"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
                <span className="absolute left-4 top-4 rounded-full border border-gold/40 bg-ink/70 px-3.5 py-1 font-serif text-sm text-gold-light backdrop-blur-md">
                  {s.n}
                </span>
              </div>
              <figcaption className="mt-5">
                <h3 className="font-serif text-2xl text-cream">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-stone">{s.desc}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
